import React, { Fragment } from 'react'

import { cn } from '@/utils/mergeClassNames'

interface HighlightedTextProps {
  highlightClassName?: string
  query?: string
  text?: string | null
}

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

export function HighlightedText({
  highlightClassName,
  query = '',
  text = '',
}: HighlightedTextProps) {
  const keyword = query.trim()
  if (!text || !keyword) return <>{text}</>

  const matcher = new RegExp(`(${escapeRegExp(keyword)})`, 'gi')
  const exactMatcher = new RegExp(`^${escapeRegExp(keyword)}$`, 'i')

  return (
    <>
      {String(text)
        .split(matcher)
        .map((part, index) =>
          exactMatcher.test(part) ? (
            <mark
              key={`${part}-${index}`}
              className={cn(
                'bg-yellow-300 font-semibold text-inherit',
                highlightClassName,
              )}
            >
              {part}
            </mark>
          ) : (
            <Fragment key={`${part}-${index}`}>{part}</Fragment>
          ),
        )}
    </>
  )
}
